import "../../base.js";
import "../../mixins/conditional_visibility.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Header ??= {};
window.AppointmentBooking.Wizard.Views.Header.MainMenu ??= {};

AppointmentBooking.Wizard.Views.Header.MainMenu.Item = class Item extends (
  AppointmentBooking.Wizard.Views.Mixins.ConditionalVisibilty(AppointmentBooking.Wizard.Views.Base)
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);
    return (this.booking = this.model.get("booking"));
  }
};
AppointmentBooking.Wizard.Views.Header.MainMenu.Item.prototype.tagName = "div";
AppointmentBooking.Wizard.Views.Header.MainMenu.Item.prototype.className = "appointment-booking-wizard-main-menu-item";
